import React from 'react'
import Link from 'gatsby-link'

const acupunctureTreats = () => (
  <div>
    <h2>What does Acupuncture Treat?</h2>
    <span>
      <i>
        The National Institute of Health (NIH) and World Health Organization
        (WHO) recognize acupuncture as effective for treating the following
        conditions:
      </i>
    </span>
    <br />
    <br />
    <ul>
      <li>
        <strong>Ear, Eye, Nose, Throat Disorders:</strong> Sinusitis • Sore
        throat • Hay fever • Earache • Nerve deafness • Ringing in the ears •
        Dizziness • Poor eyesight
      </li>
      <li>
        <strong>Circulatory Disorders:</strong> High blood pressure • Angina
        pectoris • Arteriosclerosis • Anemia
      </li>
      <li>
        <strong>Gastrointestinal Disorders:</strong> Irritable bowel syndrome • Spastic colon • Colitis • Constipation •
      Diarrhea • Food Allergies • Ulcers • Gastritis • Abdominal bloating •
      Hemorrhoids
      </li>
      <li>
        <strong>Gynecological and Genitourinary Disorders:</strong> Premenstrual
      syndrome (PMS) • Irregular, heavy, or painful menstruation • Endometriosis
      • Menopause • Fibroids • Chronic bladder infection • Complications in
      pregnancy • Morning sickness • Kidney stones • Impotence • Infertility in
      men and women • Sexual dysfunction
      </li>
      <li>
      <strong>Immune Disorders:</strong> Candida • Chronic fatigue • HIV and AIDS • Epstein Barr virus • Allergies • Lupus • MS • Hepatitis
      </li>
      <li>
      <strong>Addiction:</strong> Smoking Cessation • Drugs • Alcohol
      </li>
      <li>
      <strong>Emotional and Psychological Disorders:</strong> Anxiety • Insomnia • Depression • Stress
      </li>
      <li>
      <strong>Musculoskeletal and Neurological Disorders:</strong> Arthritis • Neuralgia •
      Sciatica • Back pain • Bursitis • Tendonitis • Stiff neck • Bell’s palsy •
      Trigeminal Neuralgia • Headaches and Migraines • Stroke • Cerebral palsy •
      Polio • Sprains • Muscle spasms • Shingles
      </li>
      <li>
      <strong>Respiratory Disorders:</strong> Asthma • Emphysema • Bronchitis • Colds and flu
      </li>
      <li>
      <strong>Miscellaneous:</strong> Chemotherapy and
      radiation side effects • Diabetes • Dermatological disorders • Weight control
      </li>
    </ul>
    <br />
  </div>
)

export default acupunctureTreats


// WEBPACK FOOTER //
// ./src/pages/acupuncture-treats.js